// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CurrentLang } from '@shared/localizations/Resources';
export class InstrumentGroup {
    constructor(message, dataCache) {
        this.InstrumentType = null;
        this._disclosedQuantityMinCoefficient = null;
        this.TypeId = message.TypeId;
        this.Id = message.TypeId;
        this.SuperTypeId = message.SuperTypeId;
        this.Name = message.TypeName;
        this.MinimalLot = message.MinimalLot;
        this.MaximalLot = message.MaximalLot;
        this.FDataCache = dataCache;
        this.FLanguageAliases = message.LanguageAliases || {};
        this.ExtendedFields = message.ExtendedFields || {};
        this.InstrumentType = message.InstrumentType;
    }
    DisplayName() {
        let alias = '';
        if (this.FLanguageAliases) {
            alias = this.FLanguageAliases[CurrentLang];
        }
        return alias || this.Name;
    }
    toString() {
        return this.Name;
    }
    DisclosedQuantityMinCoefficient() {
        if (isValidNumber(this._disclosedQuantityMinCoefficient) && this._disclosedQuantityMinCoefficient !== 0) {
            return this._disclosedQuantityMinCoefficient;
        }
        if (isNullOrUndefined(this.ExtendedFields)) {
            return null;
        }
        const result = this.ExtendedFields[InstrumentGroup.DISCLOSED_QUANTITY_MIN_COEFFICIENT_KEY];
        if (!isValidString(result)) {
            return null;
        }
        this._disclosedQuantityMinCoefficient = parseFloat(result);
        return this._disclosedQuantityMinCoefficient;
    }
}
InstrumentGroup.DISCLOSED_QUANTITY_MIN_COEFFICIENT_KEY = 'Disclosed qty';
